import { createFileRoute, Link, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/admin/trash")({
  component: RouteComponent,
});

function RouteComponent() {
  const links = [
    {
      name: "Projects",
      path: "/dashboard/admin/trash",
    },
    {
      name: "Users",
      path: "/dashboard/admin/trash/users",
    },
    {
      name: "Workers",
      path: "/dashboard/admin/trash/workers",
    },
    {
      name: "Project Hours",
      path: "/dashboard/admin/trash/project-hours",
    },
    {
      name: "Agencies",
      path: "/dashboard/admin/trash/agencies",
    },
  ] as const;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-2">
        {links.map((link) => (
          <Link
            activeOptions={{ exact: true }}
            activeProps={{
              className:
                "text-primary font-medium border-b-2 border-primary transition-colors hover:text-primary/80",
            }}
            className="text-muted-foreground hover:text-foreground px-2 py-1"
            key={link.path}
            to={link.path}
          >
            {link.name}
          </Link>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
